import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import sal from "sal.js";
function StatSection() {
  const committeeHomePage = useSelector(
    (x) => x?.committee?.getCommitteeHomePageIntegrationDataResponse?.data
  );
  const ImageURL = process.env.REACT_APP_API_IMAGE_URL;
  useEffect(() => {
    sal();
  }, [committeeHomePage]);

  // Build cards dynamically from object keys
  const cards = useMemo(() => {
    if (!committeeHomePage) return [];

    // Get all keys like committeeSectionFiveCardOneTitle, committeeSectionFiveCardTwoImage...
    const entries = Object.entries(committeeHomePage);

    // Group by "CardOne", "CardTwo", etc.
    const grouped = {};

    entries.forEach(([key, value]) => {
      const match = key.match(
        /committeeSectionFive(Card\w+)(Image|Title|Description)/
      );
      if (match) {
        const [, cardKey, field] = match; // e.g. "CardOne", "Title"
        if (!grouped[cardKey]) grouped[cardKey] = {};
        grouped[cardKey][field.toLowerCase()] = value; // { image: "...", title: "...", description: "..." }
      }
    });

    return Object.values(grouped).filter(
      (c) => c.image || c.title || c.description
    );
  }, [committeeHomePage]);

  return (
    cards.length > 0 && (
      <section class="stats-section">
        <div class="container">
          {/* <div class="row justify-content-center gy-4">
          <div
            className="col-md-6 col-lg-3 stat-item"
            data-sal="slide-up"
            data-sal-duration="900"
          >
            <img
              src={
                ImageURL + committeeHomePage?.committeeSectionFiveCardOneImage
              }
              alt="Tent_Icon"
            />
            <div className="stat-number">
              {committeeHomePage?.committeeSectionFiveCardOneTitle}
            </div>

            <p
              className="stat-text"
              dangerouslySetInnerHTML={{
                __html:
                  committeeHomePage?.committeeSectionFiveCardOneDescription,
              }}
            ></p>
          </div>

          <div
            className="col-md-6 col-lg-3 stat-item"
            data-sal="slide-up"
            data-sal-duration="900"
          >
            <img
              src={
                ImageURL + committeeHomePage?.committeeSectionFiveCardTwoImage
              }
              alt="Tent Icon"
            />
            <div className="stat-number">
              {committeeHomePage?.committeeSectionFiveCardTwoTitle}
            </div>
            <div
              className="stat-text"
              dangerouslySetInnerHTML={{
                __html:
                  committeeHomePage?.committeeSectionFiveCardTwoDescription,
              }}
            ></div>
          </div>

          <div
            className="col-md-6 col-lg-3 stat-item"
            data-sal="slide-up"
            data-sal-duration="900"
          >
            <img
              src={
                ImageURL + committeeHomePage?.committeeSectionFiveCardThreeImage
              }
              alt="Tent Icon"
            />
            <div className="stat-number">
              {committeeHomePage?.committeeSectionFiveCardThreeTitle}
            </div>
            <div
              className="stat-text"
              dangerouslySetInnerHTML={{
                __html:
                  committeeHomePage?.committeeSectionFiveCardThreeDescription,
              }}
            ></div>
          </div>

          <div
            className="col-md-6 col-lg-3 stat-item"
            data-sal="slide-up"
            data-sal-duration="900"
          >
            <img
              src={
                ImageURL + committeeHomePage?.committeeSectionFiveCardFourImage
              }
              alt="Tent Icon"
            />
            <div className="stat-number">
              {committeeHomePage?.committeeSectionFiveCardFourTitle}
            </div>
            <div
              className="stat-text"
              dangerouslySetInnerHTML={{
                __html:
                  committeeHomePage?.committeeSectionFiveCardFourDescription,
              }}
            ></div>
          </div>
        </div> */}
          <div className="row justify-content-center gy-4">
            {cards.map((card, index) => (
              <div
                key={index}
                className="col-md-6 col-lg-3 stat-item"
                data-sal="slide-up"
                data-sal-duration="900"
              >
                <div style={{ height: "80px" }}>
                  {card.image && (
                    <img
                      src={ImageURL + card.image}
                      alt={card.title || "Card Image"}
                      height={"80px"}
                    />
                  )}
                </div>
                <div style={{ height: "63px" }}>
                  {card.title && (
                    <div className="stat-number">{card.title}</div>
                  )}
                </div>
                {card.description && (
                  <div
                    className="stat-text text-start"
                    dangerouslySetInnerHTML={{ __html: card.description }}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    )
  );
}

export default StatSection;
